import id from '@/helpers/id'

/**
 * Created by Fernando Torres on 15/03/2018.
 */
export default {
  model () {
    return {
      $id: id(),
      $collapsed: false,
      $group: 'section',
      $children: [],
      name: '',
      description: '',
      helper: ''
    }
  },
  rules: {
    name: [{ required: true, message: 'Defina un nombre para la sección', trigger: 'change' }],
    description: [],
    helper: [],
    index: []
  }
}



// WEBPACK FOOTER //
// ./src/modules/designer/api/section.model.js